import { RemainingCredits } from "./RemainingCredits";
import { SessionsSection } from "./sessions-info/SessionsSection";
import { ApiKeyInput } from "./ApiKeyInput";

export function InfoSection() {
  return (
    <section className="flex w-full flex-1 flex-col gap-4">
      <ApiKeyInput />
      <RemainingCredits />
      <SessionsSection />
    </section>
  );
}
